import {
  CustomerContractFilter as Filter,
  CustomerContractsFragmentFragment as Row,
  CustomerContractSortBy,
  SortOrder
} from "@graphql";
import locale from "@bonliva-crm/locale";

export { Filter, Row };

export const initialFilter: Filter = {
  text: "",
  contractStart: null,
  contractEnd: null,
  currentContractEnd: null,
  contractProlongation: null,
  contractPriceAdjustmentDate: null,
  professions: [],
  typeOfAgreement: null,
  status: []
};

export type CustomerContractOption =
  | "customer_name_asc"
  | "customer_name_desc"
  | "customer_contract_number_asc"
  | "contract_start_asc"
  | "contract_end_asc"
  | "current_contract_end_asc"
  | "contract_prolongation_asc"
  | "contract_price_adjustment_date_asc"
  | "estimated_contract_value_asc"
  | "customer_contract_number_desc"
  | "contract_start_desc"
  | "contract_end_desc"
  | "current_contract_end_desc"
  | "contract_prolongation_desc"
  | "contract_price_adjustment_date_desc"
  | "estimated_contract_value_desc";

export const getSortOptions = (active: CustomerContractOption) =>
  [
    "customer_name_asc",
    "customer_name_desc",
    // "customer_contract_number_asc",
    "contract_start_asc",
    "contract_end_asc",
    // "current_contract_end_asc",
    "contract_prolongation_asc",
    "contract_price_adjustment_date_asc",
    "estimated_contract_value_desc",
    "estimated_contract_value_asc"
    // "customer_contract_number_desc",
    // "contract_start_desc",
    // "contract_end_desc",
    // "current_contract_end_desc",
    // "contract_prolongation_desc",
    // "contract_price_adjustment_date_desc"
  ].map((opt) => ({
    active: active === opt,
    label: locale.customerContractSorting[opt],
    value: opt
  }));

export const sortOptionToGql = (opt: CustomerContractOption) => {
  if (opt === "customer_name_asc") {
    return {
      sortBy: CustomerContractSortBy.CustomerName,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "customer_name_desc") {
    return {
      sortBy: CustomerContractSortBy.CustomerName,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "customer_contract_number_asc") {
    return {
      sortBy: CustomerContractSortBy.ContractNumber,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "contract_start_asc") {
    return {
      sortBy: CustomerContractSortBy.ContractStart,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "contract_end_asc") {
    return {
      sortBy: CustomerContractSortBy.ContractEnd,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "current_contract_end_asc") {
    return {
      sortBy: CustomerContractSortBy.CurrentContractEnd,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "contract_prolongation_asc") {
    return {
      sortBy: CustomerContractSortBy.ContractProlongation,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "contract_price_adjustment_date_asc") {
    return {
      sortBy: CustomerContractSortBy.ContractPriceAdjustmentDate,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "customer_contract_number_desc") {
    return {
      sortBy: CustomerContractSortBy.ContractNumber,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "contract_start_desc") {
    return {
      sortBy: CustomerContractSortBy.ContractStart,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "contract_end_desc") {
    return {
      sortBy: CustomerContractSortBy.ContractEnd,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "current_contract_end_desc") {
    return {
      sortBy: CustomerContractSortBy.CurrentContractEnd,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "contract_prolongation_desc") {
    return {
      sortBy: CustomerContractSortBy.ContractProlongation,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "contract_price_adjustment_date_desc") {
    return {
      sortBy: CustomerContractSortBy.ContractPriceAdjustmentDate,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "estimated_contract_value_asc") {
    return {
      sortBy: CustomerContractSortBy.EstimatedContractValue,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "estimated_contract_value_desc") {
    return {
      sortBy: CustomerContractSortBy.EstimatedContractValue,
      sortOrder: SortOrder.Desc
    };
  } else {
    return {
      sortBy: CustomerContractSortBy.ContractNumber,
      sortOrder: SortOrder.Asc
    };
  }
};
